import React, { useState, useEffect } from "react";
import Widgets from "../../HomeCards/Card";
import CurrencyFormat from "react-currency-format";
import moment from "moment";

const TransactionProjectTypeMonthlyTotal = (props) => {
  return (
    <Widgets
      icon="calendar-new"
      currency={`01-${moment().format("DD MMMM")}`}
      title="Bu Ay Eklenen Depo Sayısı"
    totalBalance={
        <CurrencyFormat
          value={props?.data}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          prefix={""}
        />
      }
    />
  );
};

export default TransactionProjectTypeMonthlyTotal;
